import React, { useEffect, useState } from 'react';

/**
 * Custom hook for handling state while storing in browser session.
 * @param sessionStorageKey session storage key
 * @param initialState initial state to pass into useState
 */
export const useStateWithSessionStorage = (
    sessionStorageKey: string,
    initialState: string | (() => string),
): [string, React.Dispatch<string>] => {
    const [value, setValue] = useState(sessionStorage.getItem(sessionStorageKey) || initialState);
    useEffect(() => {
        if (value) {
            sessionStorage.setItem(sessionStorageKey, value);
        } else {
            sessionStorage.removeItem(sessionStorageKey);
        }
    }, [value]);
    return [value, setValue];
};

export default useStateWithSessionStorage;
